import type { PayloadAction } from '@reduxjs/toolkit';

import type { PushPayload } from './_reducer.type';
import type { ToastState } from './_state.type';

/** Toast Reducer. */
export const toastReducer = {
  /**
   * Push Toast.
   *
   * @param {ToastState} state State.
   * @param {PayloadAction<PushPayload>} action Action.
   */
  toast_push: (state: ToastState, { payload }: PayloadAction<PushPayload>) => {
    state.toast.states[payload.key] = payload.state;
  },

  /**
   * Pop Toast.
   *
   * @param {ToastState} state State.
   * @param {PayloadAction<string>} action Action.
   */
  toast_pop: (state: ToastState, { payload }: PayloadAction<string>) => {
    delete state.toast.states[payload];
  },
};
